module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dimension-input",
    class: !_vm.metric && 'imperial'
  }, [(!_vm.metric) ? [_c('unit-input', {
    attrs: {
      "placeholder": "Feet",
      "mark": "'"
    },
    model: {
      value: (_vm.feet),
      callback: function($$v) {
        _vm.feet = $$v
      },
      expression: "feet"
    }
  }), _vm._v(" "), (_vm.showInches) ? [_c('unit-input', {
    attrs: {
      "placeholder": "Inches",
      "mark": "\""
    },
    model: {
      value: (_vm.inches),
      callback: function($$v) {
        _vm.inches = $$v
      },
      expression: "inches"
    }
  })] : _vm._e(), _vm._v(" "), (!_vm.showInches) ? [_c('span', {
    staticClass: "input-right-border"
  })] : _vm._e()] : (_vm.metric) ? [_c('unit-input', {
    attrs: {
      "placeholder": "Cm",
      "mark": "cm"
    },
    model: {
      value: (_vm.centimeters),
      callback: function($$v) {
        _vm.centimeters = $$v
      },
      expression: "centimeters"
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-367a2fe0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/DimensionInput.vue
// module id = 567
// module chunks = 1